import { getParameterByName } from '../utils';
import en, { TranslationKey } from './en';
import ja from './ja';
import ko from './ko';

export type LocaleCode = 'en' | 'ja' | 'ko';

const resources: Record<LocaleCode, Record<TranslationKey, string>> = { en, ja, ko };

// 부모 앱(Scripts/WebApp/Localizer.js)은 'ko-KR', 'ko-kr', 'ko' 등 여러 표기를 쓰므로 모두 받는다.
// 이 앱이 지원하지 않는 언어(ru/zh/vi/id)는 부모의 fallbackLng 과 동일하게 영어로 떨어진다.
export function toLocaleCode(language?: string | null): LocaleCode {
  const lang = (language || '').toLowerCase();
  if (lang === 'ko' || lang.startsWith('ko-')) {
    return 'ko';
  }
  if (lang === 'ja' || lang.startsWith('ja-')) {
    return 'ja';
  }
  return 'en';
}

// 부모 앱이 iframe URL 에 붙여주는 locale 파라미터가 우선이고, 없으면 브라우저 언어를 따른다.
export function detectLocale(): LocaleCode {
  const param = getParameterByName('locale');
  if (param) {
    return toLocaleCode(param);
  }
  const nav = window.navigator as Navigator & { userLanguage?: string };
  return toLocaleCode(nav.userLanguage || nav.language);
}

// 통화 중에 언어가 바뀌는 경로가 없으므로 모듈 로드 시 한 번만 판정한다.
export const locale = detectLocale();

const messages = resources[locale];

export function t(key: TranslationKey): string {
  return messages[key] || en[key];
}
